import {
    GA_VERIFICATION_EMAIL_ATTEMPT,
    GA_VERIFICATION_EMAIL_FAILED,
    GA_VERIFICATION_EMAIL_SENT,
    GA_VERIFICATION_FAILED,
    GA_VERIFICATION_SUCCESS,
} from '../constants/analytics';
import {
    trackGeneralAuthAction,
    trackGeneralPageUnloadAuthAction,
} from './general';
import { IAnalyticsDimensionsProps } from './interfaces';
import { capitalize } from './utils';

export const trackVerificationEmailAttempt = ({
    socialProvider,
    analytics,
}: {
    socialProvider: string;
    analytics?: IAnalyticsDimensionsProps;
}) => {
    trackGeneralAuthAction({
        action: GA_VERIFICATION_EMAIL_ATTEMPT,
        label: capitalize(socialProvider),
        analytics,
    });
};

export const trackVerificationEmailFailed = ({
    errorMessage,
    analytics,
}: {
    errorMessage: any;
    analytics?: IAnalyticsDimensionsProps;
}) => {
    trackGeneralAuthAction({
        action: GA_VERIFICATION_EMAIL_FAILED,
        label: errorMessage,
        analytics,
    });
};

export const trackVerificationEmailSent = ({
    socialProvider,
    analytics,
}: {
    socialProvider: string;
    analytics?: IAnalyticsDimensionsProps;
}) => {
    trackGeneralPageUnloadAuthAction({
        action: GA_VERIFICATION_EMAIL_SENT,
        label: capitalize(socialProvider),
        analytics,
    });
};

export const trackVerificationSuccessful = ({
    socialProvider,
    analytics,
}: {
    socialProvider: string;
    analytics?: IAnalyticsDimensionsProps;
}) => {
    trackGeneralAuthAction({
        action: GA_VERIFICATION_SUCCESS,
        label: capitalize(socialProvider),
        analytics,
    });
};

export const trackVerificationFailed = ({
    errorMessage,
    analytics,
}: {
    errorMessage: string;
    analytics?: IAnalyticsDimensionsProps;
}) => {
    trackGeneralAuthAction({
        action: GA_VERIFICATION_FAILED,
        label: errorMessage,
        analytics,
    });
};
